// @flow

export const isDefined = (x: mixed): boolean %checks =>
  x !== null && typeof x !== 'undefined';

export const isObject = (x: mixed): boolean %checks =>
  isDefined(x) && typeof x === 'object';

export const isFunction = (x: mixed): boolean %checks =>
  typeof x === 'function';

// For type refinements: https://flow.org/en/docs/types/mixed/
export const stringify = (x: mixed): string => (typeof x === 'string' ? x : '');
